// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__xAOdu","footer":"ModalFilter_footer__3GpkL"};